(ns hai.tasks.drawer.parts
  "The styled pieces the task drawer's searches share: the field, and the list
   of what was found for it."
  (:require
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

;; At rest a well sunk into the drawer: a shade darker than it, edged in sage,
;; a shadow inside its top. With the caret it is white in the sage ring the
;; task form's own inputs take.
(o/defstyled field-frame :div
  {:display "flex" :align-items "center" :gap "5px"
   :box-sizing "border-box"
   :min-height "30px"
   :padding "2px 4px 2px 6px"
   :border-width "1px" :border-style "solid" :border-color t/--card-sage-light
   :border-radius "12px"
   :background t/--card-forest-06
   :box-shadow "inset 0 1px 2px var(--card-forest-10)"
   :cursor "text"
   :transition "background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease"}
  [:&:focus-within
   {:border-color t/--card-sage
    :background t/--colour-white
    :box-shadow "0 0 0 3px var(--card-sage-soft-20)"}]
  [:.field-input
   {:flex "1" :min-width "0"
    :height "20px" :padding "2px 4px"
    :border "none" :outline "none"
    :background "transparent"
    :font-family "inherit" :font-size "13.5px" :font-weight "600"
    :color t/--card-forest}
   [:&::placeholder {:color t/--link-muted :font-weight "600"}]])

;; A menu's button inside the field. Applied by name: a Radix trigger needs a
;; plain :button it can put a ref on.
(o/defstyled menu-button :button
  {:flex "none"
   :display "inline-flex" :align-items "center" :gap "3px"
   :box-sizing "border-box"
   :height "24px" :padding "0 3px 0 6px"
   :border-width "1px" :border-style "solid" :border-color t/--property-3
   :border-radius "6px"
   :background t/--card-surface
   :font-family "inherit" :font-size "10px" :font-weight "800"
   :letter-spacing "0.04em" :text-transform "uppercase"
   :color t/--link-muted
   :cursor "pointer"}
  [:svg {:flex "none" :width "13px" :height "13px" :fill "currentColor"}]
  [#{:&:hover "&[data-state='open']"}
   {:border-color t/--card-sage :color t/--card-forest}])

;; Above the field, so the row nearest it is the best match, and the list grows
;; away from it.
(o/defstyled results-band :div
  {:margin-bottom "8px"}
  [:.results-top
   {:display "flex" :align-items "center" :gap "8px"
    :padding-bottom "4px"}]
  [:.results-head
   {:flex "1 1 auto" :min-width "0"
    :padding "3px 6px"
    :font-size "11.5px" :font-weight "700"
    :color t/--link-muted}]
  [:.results-close
   {:flex "none"
    :width "22px" :height "22px" :padding "0"
    :display "inline-flex" :align-items "center" :justify-content "center"
    :border "none" :border-radius "6px"
    :background t/--card-forest-06
    :color t/--card-forest-70
    :cursor "pointer"}
   [:&:hover {:background t/--card-forest-10 :color t/--card-forest}]
   [:svg {:width "14px" :height "14px" :fill "currentColor"}]]
  [:.results-rows {:display "flex" :flex-direction "column"}]
  [:.results-quiet
   {:padding "6px 10px 8px"
    :font-size "13px"
    :color t/--link-muted}])

(o/defstyled result-row :button
  {:display "grid" :grid-template-columns "26px minmax(0, 1fr)"
   :column-gap "10px" :align-items "center"
   :width "100%"
   :padding "4px 10px 4px 5px"
   :border "none" :border-radius "9px"
   :background "transparent"
   :font-family "inherit" :text-align "left"
   :color t/--card-forest
   :cursor "pointer"}
  [:&.on {:background t/--card-forest-06}]
  [:.result-text {:min-width "0"}]
  [#{:.result-label :.result-sub}
   {:display "block"
    :line-height "1.3"
    :overflow "hidden" :text-overflow "ellipsis" :white-space "nowrap"}]
  [:.result-label {:font-size "13.5px" :font-weight "700"}]
  [:.result-sub {:font-size "12.5px" :color t/--link-muted}])
